import { useEffect } from 'react';

import type { RouteComponentProps } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import ConnectorView from '../../../components/shared/connectors/connector-view';
import analytics from '../../../lib/analytics';
import { getConnectors } from '../../../lib/side-effects';

export type Props = {
  onSelectConnector: (_: RouteComponentProps['history'] | null | undefined) => void;
  isBannerHidden?: boolean;
};

const SelectConnector = (props: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // TODO: Filter top connectors via this list
    dispatch(getConnectors());
    analytics.page('SELECT_CONNECTOR_INFO');
  }, []);

  return <ConnectorView {...props} />;
};

export default SelectConnector;
